import { IFBCordovaSplashScreen } from '@app/models/splashscreen';
import { IFBCordovaQrScanner } from '@app/models/cordova-qr-scanner';
import { IFBCordovaSafariViewController } from '@app/models/cordova-safari-view-controller';
import { IFBCordovaSocialSharing } from '@app/models/cordova-social-sharing';
import { Subject } from 'rxjs';

export abstract class CordovaPluginsService {
  abstract browsertab: any;
  abstract device: any;
  abstract deviceInfo: object;
  abstract Keyboard: any;
  abstract PushNotification: any;
  abstract QRScanner: IFBCordovaQrScanner;
  abstract SafariViewController: IFBCordovaSafariViewController;
  abstract SecureStorage: any;
  abstract isSecureStorageAvailable: boolean;
  notification: any;
  abstract SocialSharing: IFBCordovaSocialSharing;
  abstract SplashScreen: IFBCordovaSplashScreen;
  abstract StatusBar: any;
  abstract universalLinks: any;
  abstract appAvailability: any;

  abstract isSafariViewControllerAvailable: Subject<boolean>;
  abstract checkIfSafariViewControllerPluginIsAvailable(): void;

  abstract initSecureStorage(): Promise<void>;
  abstract deleteFromSecureStorage(id: string): Promise<string>;
  abstract readFromSecureStorage(id: string): Promise<string>;
  abstract writeToSecureStorage(id: string, data: string): Promise<string>;
  abstract isAndroid(): boolean;
  abstract openUrl(url: string): void;
  abstract shareNativeVia(packageName: string, methodName: string, url: string, message?: string): Promise<boolean>;
  abstract canShareVia(packageName: string, url: string, message?: string): Promise<boolean>;
}
